import { useEffect, useState } from 'react';
import { LeadTimeEntry } from '../types';
import { getAllLeadTimeEntries } from '../utils/leadTimeTrackingService';
import { SalesActivityTimeRange, getRangeCutoff } from '../utils/leadAnalytics';

export function useLeadTimeEntries(range: SalesActivityTimeRange) {
  const [entries, setEntries] = useState<LeadTimeEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const all = await getAllLeadTimeEntries();
        if (cancelled) return;
        const cutoff = getRangeCutoff(range);
        const filtered = cutoff
          ? all.filter(e => e.createdAt >= cutoff)
          : all;
        setEntries(filtered);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [range]);

  return { entries, loading };
}
